/**
 * @fileoverview PUT handler for the "/api/calculated_filters/:id/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { createMutationFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createMutationFetcherFunctionWithShadowError";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { putApiCalculatedFiltersIdAppGroupIdCacheKeys } from "./constants";
import type {
  PutApiCalculatedFiltersIdAppGroupIdProps,
  PutApiCalculatedFiltersIdAppGroupIdResult,
  PutApiCalculatedFiltersIdAppGroupIdResultErrors,
} from "./types";

export const putApiCalculatedFiltersIdAppGroupId = reactQueryMutationAdapter(
  putApiCalculatedFiltersIdAppGroupIdCacheKeys,
  createMutationFetcherFunctionWithShadowError<PutApiCalculatedFiltersIdAppGroupIdResultErrors>()(
    (props: PutApiCalculatedFiltersIdAppGroupIdProps): Promise<PutApiCalculatedFiltersIdAppGroupIdResult> => {
      return fetch(
        `/api/calculated_filters/${props.calculatedFilterId}/${props.appGroupId}`,
        "PUT",
        { calculated_filter: props.calculated_filter },
        undefined,
        {
          propagateFetchRequestError: false,
        }
      );
    }
  )
);
